import { isValidUrl } from './isValidUrl';

export const getHostnameFromUrl = (url: string): string =>
	isValidUrl(url) ? new URL(url)?.hostname : '';
